export const CHAPA_SERVICES_DATA = [
    {
      slug: "reparacion-siniestros",
      title: "Reparación de Siniestros",
      description: `En LealChapaYPintura.com nos especializamos en la reparación
      integral de daños causados por siniestros. Gestionamos el proceso completo, 
      desde el peritaje y la valoración de daños, hasta la entrega final del 
      vehículo, con acabados de fábrica. Gracias a nuestro equipo de profesionales, 
      garantizamos que tu coche quede como nuevo, evitando devaluaciones futuras 
      y utilizando siempre repuestos y pinturas de alta calidad.`,
      images: [
        "/assets/img/service/service-1-3.png",
        "/assets/img/service/service-1-1.png",
      ],
      checklist: [
        "Peritaje y gestión con aseguradoras",
        "Reparaciones rápidas y garantizadas",
        "Pintura y acabados originales de fábrica",
        "Servicio de recogida y entrega del vehículo",
      ],
    },
    {
      slug: "cambio-de-color",
      title: "Cambio de Color",
      description: `Transforma la apariencia de tu vehículo con nuestro servicio 
      profesional de cambio de color. Empleamos cabinas de pintado de última 
      generación y trabajamos con pinturas de alta gama que garantizan una 
      larga duración y un acabado impecable. Podrás elegir entre una amplia 
      gama de tonalidades, efectos y texturas, siempre con la asesoría de 
      nuestros expertos para lograr el resultado que mejor se adapte a tu 
      estilo y necesidades.`,
      images: [
        "/assets/img/service/service-1-3.png",
        "/assets/img/service/service-1-1.png",

      ],
      checklist: [
        "Asesoría en la elección de color y acabado",
        "Pinturas metalizadas, mate o perladas",
        "Proceso de pintado con horno y secado controlado",
        "Garantía de larga duración y brillo excepcional",
      ],
    },
    {
      slug: "carroceria-motocicletas",
      title: "Carrocería en Motocicletas",
      description: `No solo atendemos vehículos de cuatro ruedas. Nuestro equipo 
      ofrece un servicio especializado de chapa y pintura para motocicletas, 
      enfocándonos en cada detalle para devolver su aspecto original o 
      personalizarlo por completo. Usamos materiales específicos para carenados, 
      garantizando una terminación resistente y duradera, incluso bajo 
      condiciones exigentes de uso y clima.`,
      images: [
        "/assets/img/service/service-1-3.png",
        "/assets/img/service/service-1-1.png",
      ],
      checklist: [
        "Reparación de carenados y chasis",
        "Pintura anticorrosiva y resistente a la intemperie",
        "Detalle y pulido final",
        "Personalización de colores y grafismos",
      ],
    },
    {
      slug: "lunas-y-cristales",
      title: "Lunas y Cristales",
      description: `Contamos con un servicio integral de sustitución y reparación 
      de lunas y cristales. Desde un pequeño impacto hasta la rotura completa, 
      nos encargamos de reponer el cristal con recambios oficiales y técnicas 
      que garantizan el sellado hermético y la seguridad. Además, ofrecemos 
      laminados de alta calidad para proteger el habitáculo de los rayos UV 
      y reforzar la resistencia de las ventanillas.`,
      images: [
        "/assets/img/service/service-1-3.png",
        "/assets/img/service/service-1-1.png",
      ],
      checklist: [
        "Reparación de impactos y grietas",
        "Sustitución con recambios oficiales",
        "Sellado hermético y seguro",
        "Laminados anti-UV y antirrobo",
      ],
    },
    {
      slug: "reparacion-llantas",
      title: "Reparación de Llantas",
      description: `Las llantas son un elemento clave en la estética y seguridad 
      de tu vehículo. Restauramos llantas dañadas por golpes, roces con bordillos 
      o corrosión, dejándolas con un aspecto renovado. Utilizamos procesos 
      especializados de soldadura, enderezado y pintado, cuidando cada detalle 
      para que vuelvan a lucir como nuevas y con la resistencia necesaria en 
      la conducción diaria.`,
      images: [
        "/assets/img/service/service-1-3.png",
        "/assets/img/service/service-1-1.png",
      ],
      checklist: [
        "Enderezado y soldadura de fisuras",
        "Pintura y barnizado anticorrosión",
        "Corrección de deformaciones",
        "Pulido y equilibrado final",
      ],
    },
    {
      slug: "franquiciados-y-no-franquiciados",
      title: "Franquiciados y No Franquiciados",
      description: `En LealChapaYPintura.com atendemos tanto a vehículos 
      asegurados por compañías franquiciadas como a aquellos sin franquicia. 
      Conocemos los procedimientos y requisitos de cada aseguradora, 
      optimizando el proceso de reparación y facilitando la gestión de 
      papeles y reclamaciones. Sin importar tu póliza, nos encargamos de 
      que tu vehículo reciba un servicio de calidad con plena garantía.`,
      images: [
        "/assets/img/service/service-1-3.png",
        "/assets/img/service/service-1-1.png",
      ],
      checklist: [
        "Tramitación de siniestros con cualquier compañía",
        "Asesoría sobre pagos de franquicia",
        "Documentación completa de daños y reparaciones",
        "Garantía de servicio sin sobrecostos ocultos",
      ],
    },
  ];
  